import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, kicker, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-logo">
            <img
              src="/brand/logo-em-group.png"
              alt="EM Group"
              className="h-10 w-10 object-contain"
            />
            <span className="font-outfit tracking-tight text-lg">
              EM <span className="text-white/50">Group</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"
          >
            <ArrowLeft size={16} /> Retour à l&rsquo;accueil
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="relative py-20 md:py-28 overflow-hidden border-b border-white/5">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_30%,rgba(229,36,49,0.15),transparent_55%),radial-gradient(ellipse_at_70%_70%,rgba(31,44,110,0.2),transparent_55%)]" />
        <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-10">
          {kicker && (
            <span className="text-xs uppercase tracking-[0.25em] text-[#E52431]">
              — {kicker}
            </span>
          )}
          <h1 className="mt-4 font-outfit text-4xl md:text-5xl lg:text-6xl font-light tracking-tight">
            {title}
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <article className="prose-legal space-y-8 text-white/75 font-light leading-relaxed">
            {children}
          </article>

          <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm">
            <div className="text-white/50">
              Dernière mise à jour&nbsp;:{" "}
              <span className="text-white/80">
                {new Date().toLocaleDateString("fr-FR", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </span>
            </div>
            <div className="flex gap-5 text-white/60">
              <Link
                to="/mentions-legales"
                className="hover:text-white transition-colors"
              >
                Mentions légales
              </Link>
              <Link
                to="/confidentialite"
                className="hover:text-white transition-colors"
              >
                Confidentialité
              </Link>
              <Link to="/cgv" className="hover:text-white transition-colors">
                CGV
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
